export enum TradeModelIdEnum {
  /** Actual ID used in CRM */
  Cash = 180,
}